import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const TrialLensComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="トライアルレンズ注文完了" content="トライアルレンズの注文が完了しました。"  />
      </Layout>
    </React.Fragment>
  )
}

export default TrialLensComplete;